/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component } from "react";
import moment from 'moment';
import { Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import history from '../../../App/History';
import ProductResizableTable from '../../UploadProductExcel/ProductResizableTable';
import { tableHeaderDataVirtualBundleSales as tableHeaderData } from "../../helper";

export default class VirtualBundleSalesExcelImport extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = false;
    this.isError = false;
    this.isLoading = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    
    this.state = {
      cols: [],
      rows: [],
      regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "DATE",
          dataIndex: "date",
          editable: true,
          width: 180
        },
        {
          title: "BUNDLE_ASIN",
          dataIndex: "asin",
          editable: true,
          width: 300
        },
        {
          title: "TITLE",
          dataIndex: "title",
          editable: true,
          width: 500
        },
        {
          title: "BUNDLES_SOLD",
          dataIndex: "soldQuantity",
          editable: true,
          width: 200
        },
        {
          title: "TOTAL_SALES",
          dataIndex: "amount",
          editable: true,
          width: 200
        },
      ]
    };
  }

  // Helper function to convert Excel date serial number to JavaScript Date
  excelDateToJSDate = (serial) => {
    // Excel uses 1900-01-01 as day 1, but JavaScript Date uses 1970-01-01
    // Excel also incorrectly treats 1900 as a leap year
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    return date_info;
  }

  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  onImportExcel = (event) => {
    const { files } = event.target;
    
    if (files.length === 1) {
      const file = files[0];
      
      // Check file type
      if (!(file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        || file.type === "text/csv")) {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
        this.setState({
          errorMessage: "Unknown file format!"
        });
        return false;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array', cellDates: true });
          
          // Get the first worksheet
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          
          // Convert to array of arrays (similar to react-excel-renderer format)
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
            header: 1, 
            defval: undefined,
            raw: false
          });

          const newRows = [];
          
          // Skip header row (index 0) and process data rows
          jsonData.slice(1).forEach((row, index) => {
            if (row && row !== "undefined") {
              if (row[0] !== undefined || row[1] !== undefined || row[4] !== undefined) {
                let reportDate = '';
                
                // Handle date formatting
                if (row[0] !== undefined && row[0] !== null) {
                  if (typeof row[0] === 'number') {
                    // Handle Excel serial date number
                    const date = new Date((row[0] - (25567 + 2)) * 86400 * 1000);
                    reportDate = moment(date).format('YYYY-MM-DD');
                  } else if (row[0] instanceof Date) {
                    // Handle JavaScript Date object
                    reportDate = moment(row[0]).format('YYYY-MM-DD');
                  } else {
                    // Try to parse as date string
                    const parsedDate = moment(row[0]);
                    if (parsedDate.isValid()) {
                      reportDate = parsedDate.format('YYYY-MM-DD');
                    } else {
                      // If all else fails, treat as Excel serial date
                      const date = new Date((parseFloat(row[0]) - (25567 + 2)) * 86400 * 1000);
                      reportDate = moment(date).format('YYYY-MM-DD');
                    }
                  }
                }
                
                // Handle amount field with regex validation
                let amount = '0';
                if (row[4] !== undefined && row[4] !== null) {
                  const amountStr = String(row[4]);
                  if (this.state.regexp.test(amountStr)) {
                    amount = amountStr.replace(/\$|,/g, '');
                  }
                }
                
                newRows.push({
                  date: reportDate,
                  asin: row[1] ? String(row[1]) : '',
                  title: row[2] ? String(row[2]) : '',
                  soldQuantity: row[3] === undefined ? '0' : String(row[3]),
                  amount: amount,
                });
              }
            }
          });

          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: { top: 120, fontWeight: "bold" },
              });
            });
          } else {
            this.isError = false;
            this.isEmptyCell = false;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 50
              });
            });
          } else {
            this.setState({
              cols: Object.keys(jsonData[0] || {}), // Create cols array from first row keys
              rows: newRows,
              errorMessage: null
            });
          }

        } catch (error) {
          console.error('Error reading Excel file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading Excel file!',
              duration: 5,
              closable: true,
              style: { top: 120, fontWeight: "bold" },
              maxCount: 50
            });
          });
          this.setState({
            errorMessage: "Error reading Excel file!"
          });
        }
      };

      reader.onerror = () => {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Error reading file!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
      };

      reader.readAsArrayBuffer(file);
      
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  };

  handleSubmit = async () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'Please wait....',
        duration: 10,
        style: { top: 200, fontWeight: "bold" },
        maxCount: 40
      });
    });
    
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      },
      body: JSON.stringify(this.state.rows)
    };
    
    this.isLoading = true;
    
    try {
      const response = await fetch('https://rss.getrael.com/api/amazon/virtualbundle/update', requestOptions);
      const data = await response.json();
      
      if (data.code === '200') {
        this.isLoading = false;
        this.setState({ rows: [] })
        this.input.current.value = ""
        history.push('/virtualbundlesales/details')
      } else if (data.code === '403') {
        this.isLoading = false;
        history.push('/login')
      } else {
        this.isLoading = false;
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: data.error,
            duration: 10,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
      }
    } catch (error) {
      this.isLoading = false;
      console.error('Submit error:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error uploading data. Please try again!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
    }
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    const components = {
      body: {
        //  row: EditableFormRow,
        //  cell: EditableCell
      }
    };
    
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    
    return (
      <>
        <Col md={12}>
          <Row>
            <Col md="6">
              <input 
                className="file-uploader" 
                type="file" 
                accept=".xlsx, .xls, .csv" 
                onChange={this.onImportExcel}
                ref={this.input} 
              />
              &nbsp;<Button 
                className="btn btn-sm btn-danger"
                style={{ marginTop: 16 }}
                onClick={this.clearData}
              >
                &nbsp;Clear
              </Button>
            </Col>
            <Col md="6" align="right">
              {this.state.rows.length > 0 && (
                <>
                  <Button
                    onClick={this.handleSubmit}
                    size="large"
                    type="primary"
                    className="btn btn-primary btn-sm"
                    disabled={this.isEmptyCell}
                    style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                  >
                    Submit Data
                  </Button>
                </>
              )}
              <Button
                onClick={() => history.push('/virtualbundlesales/details')}
                size="large"
                type="danger"
                className="btn btn-primary btn-sm"
                style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
              >
                Back To Virtual Bundle Sales
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12}>
              <div className="top-location" style={{ minHeight: '400' }}>
                <div>
                  {this.isLoading ? 
                    <div style={{ minHeight: '200px' }} className="row align-items-center justify-content-center">
                      <SmallLoader loading={this.isLoading} />
                    </div>
                    : 
                    <ProductResizableTable 
                      customClass="pt-0" 
                      reactTableData={{ tableHeaderData }}
                      data={this.state.rows} 
                    />
                  }
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  }
}